export const attributeSchmema = {
  "Attributes": [
    {
      "UiName": "Call Reason",
      "key": [
        "transfercallReason",
        "callReason"
      ],
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Service Requested",
      "key": "createServiceMenuTypeResponse",
      "queueGrp": [
        "Repair_Sales",
        "Tech_Spec"
      ]
    },
    {
      "UiName": "Service Address",
      "key": [
        "SRaddress",
        "customerAddress"
      ],
      "default": "Address Unknown",
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Service City",
      "key": [
        "SRcity",
        "customerCity"
      ],
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Service State",
      "key": [
        "SRstate",
        "customerState"
      ],
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Service Zip",
      "key": [
        "SRzipcode",
        "customerZipcode"
      ],
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Address Confirmed",
      "key": "addressConfirmResponse",
      "default": "Address Not Confirmed",
      "displayValue": {
        "yes": "Address Confirmed",
        "no": "Address Not Confirmed"
      },
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    }
  ],
  "Product & Coverage Details:": [
    {
      "UiName": "Product",
      "key": [
        "SRcategory",
        "SRproduct",
        "productName",
        "createServiceMenuCategoryResponse"
      ],
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Active HW",
      "key": "hwStatus",
      "default": "False",
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ],
      "switchValue":["hwProgramDesc"]
    }, {
      "UiName": "Active HW Contract no",
      "key": "hwContractNumber",
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    }, {
      "UiName": "Active Sears Protect HW",
      "key": "programStatus",
      "default": "False",
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ],
      "switchValue":["searsProtectProgramDesc"]
    }, {
      "UiName": "Active Sears Protect HW Expires",
      "key": "searsProtectExpireDate",
      "queueGrp": [
        "Repair_Sales",
        "Repair_Care",
        "Tech_Spec",
        "Parts_Care",
        "Parts_Sales",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Coverage Found",
      "key": "coverageRoute",
      "queueGrp": [
        "Repair_Sales",
        "Tech_Spec",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Symptom",
      "key": "SRsymptomSelection",
      "queueGrp": [
        "Repair_Sales",
        "Tech_Spec"
      ]
    },
    {
      "UiName": "Service Order",
      "key": [
        "serviceOrderNo",
        "serviceUnitNo"
      ],
      "queueGrp": [
        "Repair_Care",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ],
      "mergeKey" : "",
      "format" : ['-']
    },
    {
      "UiName": "Status",
      "key": "serviceOrderStatus",
      "queueGrp": [
        "Repair_Care",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Service Date",
      "key": [
        "scheduledDate",
        "scheduledStartTime",
        "scheduledEndTime"
      ],
      "queueGrp": [
        "Repair_Care",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ],
      "mergeKey" : "",
      "format" : [' ','-']
    },
    {
      "UiName": "Service Type",
      "key": "ServiceType",
      "queueGrp": [
        "Repair_Care",
        "Service_Contracts",
        "Service_Contracts_SPN"
      ]
    },
    {
      "UiName": "Order Details",
      "key": "PDagentMessage",
      "queueGrp": ["Parts_Care"]
    },
    {
      "UiName": "Order Number",
      "key": "PDorderNumber",
      "queueGrp": ["Parts_Care"]
    },
    {
      "UiName": "Subscription ID",
      "key": "PDmembershipId",
      "queueGrp": [
        "Parts_Care",
        "Parts_Sales"
      ]
    }
  ]
}

export const queue_group_mapping = {
  "Repair_Sales": ["MSO_RP_IB_ENG_SALES", "MSO_RP_IB_ENG_SALES_CA", "MSO_RP_IB_ENG_SALES_FL", "MSO_RP_IB_ENG_SALES_TX","MSO_RP_IB_SPN"],
  "Repair_Care": ["MSO_RP_IB_ENG_CARE", "MSO_RP_IB_ENG_RESCHED", "MSO_RP_IB_SPN_TRANSLATION","MSO_RP_IB_SPN"],
  "Tech_Spec": ["MSO_RP_IB_ENG_COVERED", "MSO_RP_IB_ENG_COVERED_FL", "MSO_RP_IB_ENG_COVERED_TX", "MSO_RP_IB_SPN_COVERED"],
  "Parts_Care": ["MSO_PD_IB_ENG_CARE","MSO_PD_IB_SPN"],
  "Parts_Sales": ["MSO_PD_IB_ENG_SALES","MSO_PD_IB_SPN"],
  "Service_Contracts_SPN": ["MSO_CS_IB_SPN", "NONMSO_SC_IB_SPAN_PABA", "NONMSO_SC_IB_SPAN_KSST"],
  "Service_Contracts": {
    type: "regex",
    value: {
      ST: "NONMSO_SC_IB_ENG_",
      NOTEN: "_SUPV"
    }
  }
}

// ACC-324
// sort the group name via msgGroup attribute
export const finalContact = {
  "Repair_Sales": {
    groupName:"REPAIR_SALES_SPANISH", 
    queue:"MSO_RP_IB_SPN"
  },
  "Repair_Care": {
    groupName:"REPAIR_SPANISH", 
    queue:"MSO_RP_IB_SPN"
  },
  "Parts_Care": {
    groupName:"PDCARE_SPANISH", 
    queue:"MSO_PD_IB_SPN"
  },
  "Parts_Sales": {
    groupName:"PDSALES_SPANISH", 
    queue:"MSO_PD_IB_SPN"
  }
};